module.exports = __webpack_public_path__ + "static/media/LogoPaleSinfondo.1643151c.png";